'use client'


import { LiveStreamContext, shareInfoTypes } from "@/app/livebroadcast/_config";
import { DeviceContext } from "@/context/deviceContext";
import { useContext } from "react";
import share_btn from "@/public/image/etc/site_share_btn.png"
import share_event from "@/public/image/banner/share_event.png"
import share_icon from "@/public/icon/export_icon.png"
import { webShare } from "@/util/webShare";
import { useTranslations } from "next-intl";

export default function SiteShare({mode}:{mode?:string}) {
    const { theme, HandleSelectTheme } = useContext(DeviceContext)
    const { DelViewUrl, setOpenWebShare, setShareInfo } = useContext(LiveStreamContext)

    const t = useTranslations("Text")
    
    return (
       
        <div className={`site-share-btn ${mode != "banner" ? "small":""}`}>
            <button onClick={(e)=>{
                            e.preventDefault();
                            const shareInfo = {
                                
                                url: `${window.location.protocol}//${window.location.host}`,
                                title: `[SPON TV] 스폰티비`,
                                description: `중계중에최고 스폰티비`,
                                // imageUrl: streamData.thumbnail
                            }
                            const test = webShare(shareInfo)
                            if(!test){
                                setShareInfo(shareInfo)
                                setOpenWebShare(true)
                            }
                        }}>
                {/* <span>사이트 공유하기</span>
                <span><img src={export_icon.src} alt={""}/></span> */}
                {mode == "banner" ? 
                (<img src={share_event.src} />)
                :
                (
                    // <img src={share_btn.src} />
                    <div className={'sharBtntxt flex center'}>
                        <span>{t("스폰TV 공유하기")}</span>&nbsp;
                        <img src={share_icon.src} />
                    </div>
                    // <div className={'sharBtntxt2'}>

                    // </div>
                )}
                
            </button>
        </div>
    )
}